var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.enrichedFields),function(field){return _c(field.context.component,{key:field.name,tag:"component",attrs:{"context":field.context,"model":field.model}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }